<template>
    <div class="full-height">
      <q-card-section id="scroll-table" class="q-pb-lg card-table">
      <jt-data-table
        v-if="nmInterface && datatableMoviments"
        ref="jtDataTable"
        class="table-crud"
        :buttons="datatableMoviments.buttons"
        :fields="datatableMoviments.columns"
        :nm-interface="nmInterface"
        :multiselect="true"
        selection-force
        :extraParams="extraParams"
        :is-paginated="false"
        @selection="onSelectionChange"
        @action-button="actionButton"
      />
      <br>
      <div>
        <span> {{ $gettext("TOTAL_GENERATE") }}:&nbsp;</span>
        <span class="formatedValue">R$ {{ total }}</span>
      </div>
      <industrial-movimantation-detail
        v-if="detailModal.show"
        ref="detailModal"
        :show="detailModal.show"
        v-bind="detailModal"
        @input="(show) => (detailModal.show = show)"
        @action-button="actionButtonUpdate"
      />
      <modal
        v-if="generateModal.show"
        ref="generateOrderModal"
        :show="generateModal.show"
        v-bind="generateModal"
        @input="(show) => (generateModal.show = show)"
        @action-button="generateOrder"
      />
      </q-card-section>
    </div>
  </template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
const { pageTable, modal } = JtCrud
import { repository, messageBox } from 'jtech'
import GenerateOrderState from '../GenerateOrderState'
import IndustrialMovimantationDetail from './IndustrialMovimantationDetail.vue'
import calculateTotalValue from './../preFixedBillingOrder/CalculateTotalValue'
import PageDetail from './PageDetail.vue'
  @Component({
    name: 'IndustrialMovimatation',
    components: {
      JtDataTable, IndustrialMovimantationDetail, modal, PageDetail
    },
    props: {
      itemsSelection: Array,
      params: Object
    },
    mixins: [
      pageTable
    ]
  })
class IndustrialMovimatation extends Vue {
    orderState = GenerateOrderState.getInstance();
    total = '0,00'
    extraParams = {}
    nmInterface = 'preBillingOrder.pesquisar'
    datatableMoviments = null
    rowsSelected = []
    refs = {}
    detailModal = {
      show: false,
      detail: true
    }

    generateModal = {
      show: false
    }

    onSelectionChange (items) {
      this.rowsSelected = items
    }

    async mounted () {
      this.extraParams = { ...this.extraParams, controlBatch: this.orderState.actualBatchInfos.id }
      this.datatableMoviments = await repository.resolveDatatable(this.nmInterface, this.extraParams)
    }

    @Watch('refs._data.serverData')
    calcTotalValue (newValue, oldValue) {
      this.$emit('on-change-table-data', newValue?.length)
      this.total = newValue.map(e => e.value)
      if (this.total.length != 0) {
        this.total = calculateTotalValue.calculate(newValue.map(e => e.value))
      } else {
        this.total = '0,00'
      }
    }

    updated () {
      if (this?.$refs?.jtDataTable?.$refs?.tableRef?._data) {
        this.refs = this.$refs.jtDataTable.$refs.tableRef
      }
    }

    async actionButton (button, params) {
      if (button.name === 'icDetalhar') this.openDetailModal(button, params)
      if (button.name === 'btGenerateOrder') this.openGenerateOrderModal(button, params)
    }

    async openGenerateOrderModal (button, params) {
      this.hasRowSelected()
      const forms = await repository.resolve('preBillingOrder.generatePreBillingOrderModal')
      this.generateModal = {
        show: true,
        forms: forms,
        label: button.label,
        params: params
      }
    }

    hasRowSelected () {
      if (this.rowsSelected.length === 0) {
        messageBox.warn(this.$gettext('NO_ROW_SELECTED'))
        throw 'noItemsSelectedException'
      }
    }

    async generateOrder (button, params) {
      const requestObject = {
        ...this.orderState.actualBatchInfos,
        ...params,
        preBillingOrderIds: this.rowsSelected.map(e => e.id)
      }

      await repository.resolveLogic('preBillingOrder.generateBillingOrder', requestObject)
      this.generateModal.show = false
      messageBox.success(this.$gettext('ORDERS_GENERATED_WITH_SUCCESS_MSG'), 'top-right')
      this.$refs.jtDataTable.refresh()
    }

    async openDetailModal (button, params) {
      const { id } = params
      const forms = await this.fetchDetailForm(id)
      this.detailModal = this.buildDetailModalObject(forms, params)
    }

    async fetchDetailForm (id) {
      return await repository.resolve('preBillingOrder.detalhar', { id })
    }

    buildDetailModalObject (forms, params) {
      return {
        show: true,
        forms: forms,
        label: this.$gettext('VIEW_ORDER_INFORMATION'),
        params: params,
        detail: true
      }
    }
  }
export default IndustrialMovimatation
</script>

  <style lang='stylus' scoped>
  @import '~quasar-variables';
  .formatedValue {
    font-weight: 500;
  }
  .keep-grid-data-on-colapse{
    display: none;
  }

  /deep/ td span {
    text-wrap: auto !important;
  }
  </style>
